export default __webpack_public_path__ + "static/media/unknow-state.8521ee9d.svg";